const mEditionMapPathTreeNodeFixed = {
  mEditionMapPathTreeNodeFixed: {
    steps: 'pasos'
  }
}

export default mEditionMapPathTreeNodeFixed
